var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { positionClass, text, title, identifier, isCloseBtn, noticeCount, noticeOrder } = options; 
__p+='\n<div class="feature-notice feature-notice-chain '+
((__t=( positionClass ))==null?'':__t)+
'" id="'+
((__t=( identifier ))==null?'':__t)+
'" data-order="'+
((__t=( noticeOrder ))==null?'':__t)+
'" style="display:none;">\n  <div class="feature-notice-arrow"></div>\n  <div class="feature-notice-content">\n    <div class=\'title\'>'+
((__t=( title ))==null?'':__t)+
'</div>\n    <div class=\'text\'>'+
((__t=( text ))==null?'':__t)+
'</div>\n    <div class="cta clearfix">\n      ';
 if (noticeOrder !== noticeCount){ 
__p+='\n        <div class="btn js-notice-next">Show Me More</div>\n      ';
 } 
__p+='\n      ';
 if (isCloseBtn){ 
__p+='\n        <div class="js-feature-notice-close chain-close btn">Got it!</div>\n      ';
 } 
__p+='\n    </div>\n    <div class="count">\n      ';
 for(let i = 1; i < noticeCount + 1; i++){
        let statusClass;
        if(noticeOrder === i){statusClass = 'active';}
      
__p+='\n      <i class="ra ra-circle '+
((__t=( statusClass ))==null?'':__t)+
'"></i>\n      ';
 } 
__p+='\n    </div>\n\n\n  </div>\n\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/feature_notice_chain.jst.ejs